/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import AllPcode from "../../../components/allPcode";
import './style.css';
import Measurements from "../measurements/measurements";
import measurementImg from "../../../assets/images/measurementImg.jpg";
import QuotationTypeSearch from "../../../components/quotationTypeSearch";
import CustomerTypeSearch from "../../../components/customerTypeSearch";
import { quotationAPI } from "../../../api/quotationAPI";
import CurrencyTypeSearch from "../../../components/currencyTypeSearch";
import SalesRepTypeSearch from "../../../components/salesRepTypeSearch";
import ItemTable from "../itemTable";
import ItemModal from "../itemModal/itemModal";
import { toast } from "react-toastify";
import usePcode from "../../../common/hooks/usePcode";
import dayjs from "dayjs";

export default function Quotation() {
    const { loggedPcode } = usePcode();
    const [selectedPcode, setSelectedPcode] = useState(loggedPcode);
    const [quotationNo, setQuotationNo] = useState('');
    const [description, setDescription] = useState('');
    const [cusCode, setCusCode] = useState('');
    const [cusName, setCusName] = useState('');
    const [currencyCode, setCurrenyCode] = useState('');
    const [currencyName, setCurrencyName] = useState('');
    const [salesRepCode, setSalesRepCode] = useState('');
    const [salesRepDesc, setSalesRepDesc] = useState('');
    const [attention, setAttention] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');
    const [total, setTotal] = useState('');
    const [discRate, setDiscRate] = useState(0);
    const [discAmount, setDiscAmount] = useState(0);
    const [sscl, setSscl] = useState(0);
    const [ssclAmount, setSsclAmount] = useState(0);
    const [vat, setVAT] = useState(0);
    const [vatAmt, setVATAmt] = useState(0);
    const [netTotal, setNetTotal] = useState(0);
    // const [paidAdvance, setPaidAdvance] = useState(0);
    // const [newAdvance, setNewAdvance] = useState(0);
    const [note, setNote] = useState('');
    const [deliver, setDeliver] = useState('');
    const [paymentTerms, setPaymentTerms] = useState('');
    const [items, setItems] = useState([]);

    const [isAllQuotationNoChecked, setIsAllQuotationNoChecked] = useState(true);

    const handleOpenModal = () => {
        if (!quotationNo) {
            toast.error("Quotation no is required.");
            return;
        }

        // eslint-disable-next-line no-undef
        const modal = new bootstrap.Modal(document.getElementById("measurementsModal"));
        modal.show();
    };

    const handleItemAdd = (newItem) => {
        setItems((prevItems) => [...prevItems, newItem]);
    };

    const handleSaveQuotation = () => {
        if (!cusCode) {
            toast.warn("Select the customer"); return true;
        }

        if (!currencyCode) {
            toast.warn("Select the currency"); return true;
        }

        if (!salesRepCode) {
            toast.warn("Select the sales rep"); return true;
        }

        if (!fromDate) {
            toast.warn("Enter from date"); return true;
        }

        if (!toDate) {
            toast.warn("Enter to date"); return true;
        }

        const fromDateObj = dayjs(fromDate);
        const toDateObj = dayjs(toDate);
        if (toDateObj.isBefore(fromDateObj)) {
            toast.warn("Please select a valid To Date. It should be the same or later than the From Date.");
            return true;
        }

        if (!deliveryDate) {
            toast.warn("Enter delivery date"); return true;
        }

        if (items.length === 0) {
            toast.warn("Add items to the quotation");
            return;
        }

        const quotationDetails = {
            pCode: selectedPcode,
            quotationNo: quotationNo,
            cusCode: cusCode,
            currencyCode: currencyCode,
            salesRepCode: salesRepCode,
            attention: attention,
            fromDate: fromDate,
            toDate: toDate,
            deliveryDate: deliveryDate,
            note: note,
            deliver: deliver,
            paymentTerms: paymentTerms,
            total: parseFloat(total),
            discAmt: parseFloat(discAmount),
            discRate: parseFloat(discRate),
            netTotal: parseFloat(netTotal),
            ssclAmount: parseFloat(ssclAmount),
            ssclRate: parseFloat(sscl),
            taxRate: parseFloat(vat),
            taxAmt: parseFloat(vatAmt),
            items: items.map(item => ({
                itemCode: item.itemCode,
                itemName: item.itemName,
                qty: parseFloat(item.qty),
                sellPrice: parseFloat(item.sellPrice),
                unitTotal: parseFloat(item.unitTotal),
                discAmt: parseFloat(item.discAmt),
                brandModel: item.brandModel,
                warrYear: item.warrantyYear || 0,
                warrMonth: item.warrantyMonth || 0,
                vATYesNo: item.vat,
                model: item.model,
            }))
        };

        quotationAPI
            .saveQuotationDetails(quotationDetails)
            .then(() => {
                handleClear();
                toast.success("Quotation Saved Successfully!");
            })
            .catch(err => {
                toast.error("Failed to save quotation!");
            });
    };

    const handleClear = () => {
        setQuotationNo('');
        setIsAllQuotationNoChecked(true);

        setCusCode('');
        setCusName('');

        setCurrenyCode('');
        setCurrencyName('');

        setSalesRepCode('');
        setSalesRepDesc('');

        setAttention('');
        setFromDate('');
        setToDate('');
        setDeliveryDate('');
        setTotal('');
        setDiscRate('');
        setDiscAmount('');
        setSscl('');
        setSsclAmount('');
        setVAT('');
        setVATAmt('');
        setNetTotal('');
        // setPaidAdvance('');
        // setNewAdvance('');
        setNote('');
        setDeliver('');
        setPaymentTerms('');
        setItems([]);
    }

    useEffect(() => {
        if (items && items.length > 0) {
            const currentTotal = items.reduce((sum, item) => sum + parseFloat(item.unitTotal || 0), 0);
            setTotal(currentTotal.toFixed(2));
            calculateNetTotal(currentTotal, discAmount, ssclAmount, vatAmt);
        } else {
            setTotal('');

            calculateNetTotal(0, 0, 0, 0);
        }
    }, [items]);

    // Calculate discount rate based on the amount
    const handleDiscAmountChange = (amount) => {
        setDiscAmount(amount);
        setDiscRate((amount / total * 100).toFixed(2));
        calculateNetTotal(total, amount, ssclAmount, vatAmt);
    };

    // Calculate discount amount based on the rate
    const handleDiscChange = (rate) => {
        const amount = (total * rate) / 100;
        setDiscRate(rate);
        setDiscAmount(amount.toFixed(2));
        calculateNetTotal(total, amount, ssclAmount, vatAmt);
    };

    // Calculate SSCL 
    const handleSsclRateChange = (e) => {
        const value = e.target.value;
        setSscl(value);

        const netTotalBeforeVAT = total - discAmount;
        const calculatedSsclAmount = (parseFloat(value) * netTotalBeforeVAT / 100).toFixed(2);
        setSsclAmount(calculatedSsclAmount);

        calculateNetTotal(total, discAmount, calculatedSsclAmount, vatAmt);
    };

    const handleSsclAmountChange = (e) => {
        const value = e.target.value;
        setSsclAmount(value);

        const totalWithDisc = total - discAmount;
        setSscl((parseFloat(value) / totalWithDisc * 100).toFixed(2));

        calculateNetTotal(total, discAmount, value, vatAmt);
    };

    // Calculate VAT 
    const handleVatRate = (e) => {
        const value = e.target.value;
        setVAT(value);

        const totalWithDisc = total - discAmount;
        const calculatedVatAmount = (parseFloat(value) * totalWithDisc / 100).toFixed(2);
        setVATAmt(calculatedVatAmount);

        calculateNetTotal(total, discAmount, ssclAmount, calculatedVatAmount);
    };

    const handleVatAmount = (e) => {
        const value = e.target.value;
        setVATAmt(value);

        const netTotalBeforeVAT = total - discAmount;
        setVAT((parseFloat(value) / netTotalBeforeVAT * 100).toFixed(2));

        calculateNetTotal(total, discAmount, ssclAmount, value);
    };

    // Calculate NetTotal
    const calculateNetTotal = (totalAmount, discount, ssclAmt, vatAmt) => {
        const baseTotal = totalAmount - discount;
        const net = baseTotal + parseFloat(ssclAmt || 0) + parseFloat(vatAmt || 0);
        setNetTotal(net.toFixed(2));
    };

    const handleLoadQuotationDetails = (data) => {
        setFromDate(data.fromDate.substring(0, 10));
        setToDate(data.toDate.substring(0, 10));
        setDeliveryDate(data.deliveryDate.substring(0, 10));
        setSelectedPcode(data.pCode);
        setCusCode(data.cusCode);
        setCusName(data.cusName);
        setDeliver(data.deliver);
        setDiscAmount(data.discAmt);
        setDiscRate(data.discRate);
        setNetTotal(data.netTotal);
        setPaymentTerms(data.paymentTerms);
        setSalesRepCode(data.salesRepCode);
        setSalesRepDesc(data.salesRepName);
        setSsclAmount(data.ssclAmount);
        setSscl(data.ssclRate);
        setVAT(data.taxRate);
        setVATAmt(data.taxAmt);
        setTotal(data.total);
        setCurrenyCode(data.currencyCode);
        setCurrencyName(data.currencyName);
        setItems(data.items || []);
    };

    return (
        <>
            {
                selectedPcode &&
                <QuotationTypeSearch
                    setQuotationNo={setQuotationNo}
                    setDescription={setDescription}
                    pCode={selectedPcode}
                    setIsAllQuotationNoChecked={setIsAllQuotationNoChecked}
                    onLoadQuotationDetails={handleLoadQuotationDetails}
                />
            }

            {
                selectedPcode &&
                <CustomerTypeSearch setCusCode={setCusCode} setCusName={setCusName}
                    pCode={selectedPcode}
                />
            }

            {
                selectedPcode &&
                <CurrencyTypeSearch setCurrenyCode={setCurrenyCode} setCurrencyName={setCurrencyName}
                    pCode={selectedPcode}
                />
            }

            {
                selectedPcode &&
                <SalesRepTypeSearch salesRepCode={setSalesRepCode} salesRepDesc={setSalesRepDesc}
                    pCode={selectedPcode}
                />
            }

            <ItemModal
                pCode={selectedPcode}
                handleItemAdd={handleItemAdd}
            />

            <Measurements
                pCode={selectedPcode}
                quotationNo={quotationNo}
            />

            <div className="container">
                <div className='row'>
                    <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                    <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 form__body'>
                        <h6 className='text-center'>Quotation</h6>
                        <form>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">Profit Center</label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <AllPcode
                                        setSelectedPcode={setSelectedPcode}
                                        selectedPCode={selectedPcode} />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-3 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Quotation No
                                </label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 input_field">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="inputPassword"
                                        value={quotationNo}
                                        placeholder="Auto"
                                        onChange={(e) => setQuotationNo(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                    <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                        data-bs-target="#quotationTypeSearch"
                                    ><span className="small">Find</span></button>
                                </div>
                            </div>
                            <div class="fom-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Customer
                                </label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 input_field">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cusCode"
                                        value={cusCode}
                                        onChange={(e) => setCusCode(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                    <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                        data-bs-target="#customerTypeSearch"><span className="small">Find</span></button>
                                </div>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cusName"
                                        value={cusName}
                                        onChange={(e) => setCusName(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                </div>
                            </div>
                            <div class="fom-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Currency
                                </label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={currencyCode}
                                        onChange={(e) => setCurrenyCode(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                    <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                        data-bs-target="#currencyTypeSearch"><span className="small">Find</span></button>
                                </div>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={currencyName}
                                        onChange={(e) => setCurrencyName(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                </div>
                            </div>
                            <div class="fom-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Sales Rep
                                </label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-2 col-xl-2 input_field">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cusCode"
                                        value={salesRepCode}
                                        onChange={(e) => setSalesRepCode(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div className="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 text-center px-0">
                                    <button type="button" className="btn btn-sm btn-secondary m-0 px-sm-1" data-bs-toggle="modal"
                                        data-bs-target="#salesRepTypeSearch"><span className="small">Find</span></button>
                                </div>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="cusName"
                                        value={salesRepDesc}
                                        onChange={(e) => setSalesRepDesc(e.target.value)}
                                        disabled
                                    />
                                </div>
                                <div class="col-3 col-xs-12 col-sm-12 col-md-3 col-lg-1 col-xl-1 form-check">
                                </div>
                            </div>
                            <div class="fom-group row">
                                <label for="staticEmail"
                                    class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">
                                    Attention
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-3 col-lg-9 col-xl-9 input_field">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id="attention"
                                        value={attention}
                                        onChange={(e) => setAttention(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">From Date</label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input
                                        type="date"
                                        class="form-control"
                                        id="fromDate"
                                        value={fromDate}
                                        onChange={(e) => setFromDate(e.target.value)}
                                    />
                                </div>
                                <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">To Date</label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 date_input_field">
                                    <input
                                        type="date"
                                        class="form-control"
                                        id="toDate"
                                        value={toDate}
                                        onChange={(e) => setToDate(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Delivery Date</label>
                                <div class="col-9 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input
                                        type="date"
                                        class="form-control"
                                        id="inputPassword"
                                        value={deliveryDate}
                                        onChange={(e) => setDeliveryDate(e.target.value)}
                                    />
                                </div>
                            </div>

                            <hr />

                            {/* add item */}
                            <div class="form-group row">
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9">
                                </div>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                                    <button type="button"
                                        className="btn btn-secondary form-control mt-1"
                                        data-bs-toggle="modal"
                                        data-bs-target="#itemModal"
                                    ><span className="small">+ Add</span></button>
                                </div>
                            </div>

                            {/* item table */}
                            {items.length > 0 ? (
                                <div className="row">
                                    <div className="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <ItemTable
                                            pCode={selectedPcode}
                                            items={items}
                                            setItems={setItems}
                                        />
                                    </div>
                                    <hr />
                                </div>
                            ) : (
                                <div></div>
                            )}

                            {/* summary */}
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                    Total
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={total}
                                        onChange={(e) => setTotal(e.target.value)}
                                        disabled />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Disc%</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input type="number" class="form-control" id="inputPassword"
                                        value={discRate}
                                        onChange={(e) => handleDiscChange(e.target.value)}
                                    />
                                </div>
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">Disc Amt</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 date_input_field">
                                    <input type="number" class="form-control" id="inputPassword"
                                        value={discAmount ?? 0}

                                        onChange={(e) => handleDiscAmountChange(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">SSCL%</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={sscl}
                                        onChange={handleSsclRateChange}
                                    />
                                </div>
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">SSCL Amt</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 date_input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={ssclAmount}
                                        onChange={handleSsclAmountChange}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">VAT%</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={vat}
                                        onChange={handleVatRate}
                                    />
                                </div>
                                <label for="staticEmail" class="col-2 col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-form-label">VAT Amt</label>
                                <div class="col-4 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 date_input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={vatAmt}
                                        onChange={handleVatAmount}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                    Net Total
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={netTotal}
                                        onChange={(e) => setNetTotal(e.target.value)}
                                        disabled />
                                </div>
                            </div>
                            {/* <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                    Paid Advance
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={paidAdvance}
                                        onChange={(e) => setPaidAdvance(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                    New Advance
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={newAdvance}
                                        onChange={(e) => setNewAdvance(e.target.value)} />
                                </div>
                            </div> */}

                            <hr />
                            <div class="form-group row">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingOne">
                                            <button class="accordion-button" type="button" data-bs-toggle="collapse"
                                                data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                                style={{ padding: '0.25rem 0.5rem', fontSize: '14px' }}>
                                                <label for="staticEmail"
                                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                                    Note
                                                </label>
                                            </button>
                                        </h2>
                                        <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                                    value={note}
                                                    onChange={(e) => setNote(e.target.value)}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="accordion-item">
                                        <h2 class="accordion-header" id="headingTwo">
                                            <button class="accordion-button collapsed"
                                                style={{ padding: '0.25rem 0.5rem', fontSize: '14px' }}
                                                type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                <label for="staticEmail"
                                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                                    Deliver
                                                </label>
                                            </button>
                                        </h2>
                                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                            <div class="accordion-body">
                                                <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                                    value={deliver}
                                                    onChange={(e) => setDeliver(e.target.value)}
                                                ></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <hr />

                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-form-label">
                                    Payments Terms
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9 input_field">
                                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3"
                                        value={paymentTerms}
                                        onChange={(e) => setPaymentTerms(e.target.value)}
                                    ></textarea>
                                </div>
                            </div>

                            <hr />

                            <div class="form-group row">
                                <label for="staticEmail"
                                    class="col-xs-12 col-sm-12 col-md-6 col-lg-12 col-xl-12 col-form-label">
                                    To Balance To Be Paid:
                                </label>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9">
                                    <input type="text" class="form-control" id="inputPassword"
                                        value={netTotal}
                                        onChange={(e) => setNetTotal(e.target.value)}
                                        disabled
                                    />
                                </div>
                            </div>

                            <hr />
                            <div class="form-group row">
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"></div>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-9 col-xl-9">
                                    <div class="card measuremet_card">
                                        <img class="card-img-top" src={measurementImg} alt="Card image cap" />
                                        <div class="card-body text-center bg-dark">
                                            <button type="button"
                                                className="btn btn-sm btn-light"
                                                onClick={handleOpenModal}
                                            >
                                                <span className="small">Add Measurements</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-12 col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3"></div>
                            </div>

                            <hr />

                            <div className='row'>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                    <button type="button" className="btn btn-dark form-control mt-1"
                                        onClick={() => handleSaveQuotation()}>Save</button>
                                </div>
                                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6'>
                                    <button type="button"
                                        className="btn btn-dark form-control mt-1"
                                        onClick={() => handleClear()}
                                    >
                                        Clear</button>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className='col-xs-0 col-sm-0 col-md-3 col-lg-3 col-xl-3 col-xxl-3'></div>
                </div>
            </div>
        </>
    )
}